module.exports = ":host {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/datawarehouse/components/data-warehouse-dashboard/data-warehouse-dashboard.component.scss
// module id = ./src/app/datawarehouse/components/data-warehouse-dashboard/data-warehouse-dashboard.component.scss
// module chunks = main